import React from 'react'
import getConfig from 'next/config'
import { PageLayout } from '@grandvision/layout'
import { SearchIndex } from '@grandvision/search'
import { BloomreachApi, CmsFooter, CmsHeader } from '@grandvision/bloomreach'

import { isMultilingualEnabled, isMyAccountEnabled, isSearchEnabled } from '../util/feature-toggle'

const { publicRuntimeConfig } = getConfig()
const { indexes, productIndex } = publicRuntimeConfig.algolia
const siteName = publicRuntimeConfig.site.name

type Props = {
  children: React.ReactNode
  pageModel: BloomreachApi.PageModel
  asPath: string
  renderHeader?: boolean
  renderFooter?: boolean
  renderSiteNav?: boolean
  preview?: boolean
  isSolaris?: boolean
  isSearchEnabledOnSmallScreens?: boolean
}

const handleSearch = (query: string, type: string): void => {
  let searchRoute: string = ''
  const storeIndex = indexes && indexes.find((index: SearchIndex) => index.type === 'stores')

  switch (type) {
    case 'products':
      searchRoute = `${productIndex.targetPath}${encodeURIComponent(query)}`
      break
    case 'stores':
      searchRoute = `${storeIndex.targetPath}${encodeURIComponent(query)}`
      break
  }

  try {
    window.location.assign(searchRoute)
  } catch (error) {
    console.log(error)
  }
}

const Layout: React.FC<Props> = ({
  children,
  pageModel,
  asPath,
  isSolaris = false,
  preview = false,
  renderHeader = true,
  renderFooter = true,
  renderSiteNav = true,
  isSearchEnabledOnSmallScreens,
}) => {
  if (!pageModel) {
    return null
  }

  const header = renderHeader ? (
    <CmsHeader
      pageModel={pageModel}
      asPath={asPath}
      preview={preview}
      isMyAccountEnabled={isMyAccountEnabled}
      isSearchEnabled={isSearchEnabled}
      isSearchEnabledOnSmallScreens={isSearchEnabledOnSmallScreens}
      isMultilingualEnabled={isMultilingualEnabled}
      isSolaris={isSolaris}
      onSubmitSearch={handleSearch}
      renderSiteNav={renderSiteNav}
      siteName={siteName}
    />
  ) : (
    undefined
  )

  const footer = renderFooter ? (
    <CmsFooter pageModel={pageModel} preview={preview} siteName={siteName} />
  ) : (
    undefined
  )

  return (
    <PageLayout isSolaris={isSolaris} header={header} footer={footer} hasSiteNav={renderSiteNav}>
      {children}
    </PageLayout>
  )
}

export default Layout
